import { object, string } from 'yup';

import { __t } from '../trans';

export const defaultDynamicFieldLengthLimit = 250;
export const mapDynamicFieldToName = ({ _id }, index) => _id || `field-${index}`;
export const mapDynamicInputsToValidationSchema = ({ items }) =>
    object({
        ...items.reduce((acc, item, index) => {
            const field = mapDynamicFieldToName(item, index);
            let validator = string()
                .trim()
                .max(item.size || defaultDynamicFieldLengthLimit, __t('field_too_long'));

            if (item.required) {
                validator = validator.required(__t('field_required'));
            }

            switch (item.type) {
                case 'email': {
                    validator = validator.email(__t('field_email'));

                    break;
                }
                case 'phone': {
                    validator = validator.matches(/\+?[\d\-\s()]{5,}/, {
                        name: 'phone',
                        message: __t('field_phone'),
                        excludeEmptyString: true,
                    });

                    break;
                }
            }

            acc[field] = validator;

            return acc;
        }, {}),
    });
